import { ChangeDetectionStrategy, Component, computed, inject, input, ViewEncapsulation } from '@angular/core';
import { IAccountFormat } from '@partners/api';
import { DebitsFacade } from '../../facades/debits';

@Component({
  selector: 'account-label',
  standalone: true,

  template: `
    @if(bankName$$()) {
    <div class="mrg-bt-xs">
      {{ bankNameIntroText$$() }}
      <span class="font--medium">{{ bankName$$() }}</span>
    </div>
    } @if(accountNumber$$()) {

    <div class="nowrap mrg-bt-xs">
      {{ accountIntroText() }}
      <span class="font--medium text-decoration--none">
        {{ branchWithAccount$$() }}
      </span>
    </div>
    } @if (accountOwner$$()) {
    <div class="nowrap mrg-bt-xs">
      <span class="pdd-lt-xs">{{ accountOwnerIntroText$$() }}</span>
      <span class="font--medium">{{ accountOwner$$() }}</span>
    </div>
    }
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'account-label',
    '[class.inline]': 'isInlineDisplay()'
  }
})
export class AccountLabelComponent {
  branchWithAccount$$ = computed<string>(() => {
    if (this.branchCode$$()) {
      return `${this.branchCode$$()}-${this.accountNumber$$()}`;
    }
    return `${this.accountNumber$$()}`;
  });

  accountNumber$$ = computed<number>(() => {
    return this.accountData$$()?.accountNumber;
  });
  branchCode$$ = computed<number>(() => {
    if (this.dataScope() === 'full') {
      return this.accountData$$()?.branchCode;
    }
    return undefined;
  });
  bankName$$ = computed<string>(() => {
    if (this.dataScope() === 'full') {
      return this.accountData$$()?.bankName;
    }
    return undefined;
  });
  branchName$$ = computed<string>(() => {
    if (this.dataScope() === 'full') {
      return this.accountData$$()?.branchName;
    }
    return undefined;
  });
  accountOwner$$ = computed<string>(() => {
    if (this.dataScope() === 'full') {
      return this.accountData$$()?.accountOwnerName;
    }
    return undefined;
  });

  dataScope = input<'full' | 'account-number'>('full');

  isInlineDisplay = computed(() => this.dataScope() === 'account-number');

  accountIntroText = input('חשבון', {
    alias: 'accountIntroText'
  });
  bankNameIntroText$$ = input('בנק', {
    alias: 'bankNameIntroText'
  });
  accountOwnerIntroText$$ = input('על שם', {
    alias: 'accountOwnerIntroText'
  });

  private _debitsFacade = inject(DebitsFacade);

  private accountData$$ = computed<IAccountFormat>(() => {
    return this._debitsFacade.accountFormat$$();
  });
}
